<template>
  <div class="text-display">
    <span class="condition-name">{{ condition.name }}</span>
    <span class="compare-method">{{ condition.defaultVal.compareMethod }}</span>
    <dm-select
      v-model="textQuery.items"
      multiple
      filterable
      clearable
      allow-create
      remote
      default-first-option
      placeholder="请输入"
      no-data-text="请输入后再选择"
      :remote-method="remoteMethodDebounced"
      :class="{ 'required-hint': !result }"
    >
      <el-option
        v-for="item in allOptions"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      ></el-option>
    </dm-select>
  </div>
</template>

<script>
import { getDistinctTextValueList } from "@/api/bi"
import DmSelect from "@/components/BaseComponents/DmSelect"

export default {
  name: "textDisplay",
  props: {
    condition: Object,
    charts: Array,
    filterList: Array
  },
  components: {
    DmSelect
  },
  data() {
    return {
      textQuery: {
        items: []
      },
      result: true,
      remoteOptions: [],
      searchText: "",
      remoteMethodDebounced: this._.debounce(this.remoteMethod, 100)
    }
  },
  computed: {
    valueOptions() {
      return this.condition.defaultVal.values.map(kind => ({ label: kind, value: kind }))
    },
    allOptions() {
      return this._.uniqBy(this.remoteOptions.concat(this.valueOptions), "value")
    }
  },
  watch: {
    condition: {
      handler() {
        this.initData()
      },
      deep: true,
      immediate: true
    },
    textQuery: {
      handler() {
        this.$emit("getVerifyResult")
        this.$emit("getVarValueMap")
      },
      deep: true,
      immediate: true
    },
    filterList: {
      handler() {
        this.remoteMethodDebounced(this.searchText)
      }
    }
  },
  methods: {
    initData() {
      this.textQuery.items = this.condition.defaultVal?.values
      this.remoteMethodDebounced()
    },
    remoteMethod(query) {
      this.searchText = query
      if (this.condition.selectChartId) {
        let sheetId = this.charts.find(chart => chart.chartId === this.condition.selectChartId)
          ?.sheetId
        let controlId = this.condition.charts.find(
          chart => chart.chartId === this.condition.selectChartId
        ).controlId
        getDistinctTextValueList({
          searchText: query,
          controlId: controlId,
          searchParam: { sheetId, page: 1, size: 100, filtersList: [this.filterList] }
        }).then(res => {
          this.remoteOptions = res.map(info => ({ label: info, value: info }))
        })
      } else {
        this.remoteOptions = []
      }
    },
    getTextFilters(chart) {
      if (!this._.isEmpty(this.textQuery.items)) {
        let filter = {}
        filter.compareMethod = this.condition.defaultVal?.compareMethod
        filter.key = chart.controlId
        filter.type = this.condition.type
        filter.value = null
        filter.varItems = this.textQuery.items.map(item => ({ value: item, var: false }))
        return [filter]
      } else {
        return []
      }
    },
    getVerify() {
      let result = true
      if (this._.isEmpty(this.textQuery.items)) result = false
      this.result = result
      return result
    },
    getValue() {
      return this.textQuery.items
    }
  }
}
</script>

<style lang="scss" scoped>
.text-display {
  display: flex;
  align-items: center;
  .condition-name {
    margin-right: 10px;
    white-space: nowrap;
  }
  .compare-method {
    margin-right: 10px;
    white-space: nowrap;
    width: unset;
  }
  .required-hint {
    ::v-deep {
      .el-input__inner {
        border-color: #f56c6c;
      }
      .container {
        border-color: #f56c6c;
      }
    }
  }
}
</style>
